import { memo } from 'react';
import { Box, Skeleton } from '@mui/material';

function CustomTablePaginationSkeleton() {
  return (
    <Box
      sx={{
        px: '10px',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr 1fr 3fr 1fr 1fr', lg: '1fr 1fr 4fr 1fr 1fr' },
        border: theme => `solid thin ${theme.palette.mind.grey.A50}`,
        height: 52,
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
      }}
    >
      <Box sx={{ gridColumn: 1, gridRow: 1 }} />
      <Box sx={{ gridColumn: 2, gridRow: 1 }} />
      <Box sx={{ gridColumn: 3, gridRow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Skeleton width="24px" height="40px" sx={{ mx: '8px' }} />
        <Skeleton width="24px" height="40px" sx={{ mx: '8px' }} />
        <Skeleton variant="circular" width="24px" height="24px" sx={{ margin: '8px' }} />
        <Skeleton width="24px" height="40px" sx={{ mx: '8px' }} />
        <Skeleton width="24px" height="40px" sx={{ mx: '8px' }} />
      </Box>
      <Box sx={{ gridColumn: 5, gridRow: 1, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
        <Skeleton width="60px" height="40px" sx={{ mx: '8px' }} />
        <Skeleton width="80px" height="40px" sx={{ mx: '8px' }} />
      </Box>
    </Box>
  );
}

export default memo(CustomTablePaginationSkeleton);
